// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__n7Z-K","form":"styles_form__bB5Fc"};